import { useState } from "react";
import { Grid, Row, Col } from "react-flexbox-grid";
import { Input, Link, Button } from "components/core";
import { resetPassword } from "helpers";
import { useWindowSize } from "hooks";
import { useHistory } from "react-router-dom";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import styled from "./Login/Login.module.css";

const SchemaSignIn = yup.object().shape({
  email: yup
    .string()
    .email("El correo ingreso no es valido")
    .required("Ingrese su correo para continuar"),
});

export const ResetPassword = () => {
  // eslint-disable-next-line no-unused-vars
  const [isLoading, setLoading] = useState(false);
  const history = useHistory();
  const { width } = useWindowSize();
  const isMobile = width <= 425;

  const { handleSubmit, register, errors } = useForm({
    resolver: yupResolver(SchemaSignIn),
  });

  const onSubmit = (data) => {
    console.log(data);
  };

  return (
    <Grid fluid className={styled.bgContentResetPassword}>
      <Row
        data-aos="fade-zoom-in"
        data-aos-easing="ease-in-back"
        data-aos-delay="50"
        data-aos-offset="0"
        className="m0"
      >
        <Grid fluid={isMobile} className="pl2 pr0">
          <Row
            center="xs"
            middle="xs"
            className="min-vh-100"
            data-aos="fade-up"
            data-aos-duration="2000"
          >
            <div className={styled.blurredBox}>
              <div className={styled.userLoginBox}>
                <h3 className="mt3">Recuperar contraseña</h3>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Input
                    bordered
                    type="email"
                    name="email"
                    placeholder="ejemplo@gmail.com"
                    ref={register}
                    error={errors.email?.message}
                  />

                  <Col md={12} className="mt4">
                    <Button
                      htmlType="submit"
                      type="primary"
                      size="large"
                      shape="round"
                      className="w-100"
                    >
                      {isLoading ? "Cargando..." : "Restablecer contraseña"}
                    </Button>
                  </Col>

                  <Row center="xs">
                    <Col md={12} className="mt2">
                      <Link to="/" className=" text-center">
                        Ir a Inicio de sesión
                      </Link>
                    </Col>
                  </Row>
                </form>
              </div>
            </div>
          </Row>
        </Grid>
      </Row>
    </Grid>
  );
};
